export function addToFavourites(id) {
    var container = $(".timeline_entry#" + id);
    var tmpCommunityType = 1; //Standardmäßig Timeline
    if (container.hasClass("blog_entry")) {
        tmpCommunityType = 5; // Blog
    } else if (container.hasClass("event_entry")) {
        tmpCommunityType = 6; // Event
    } else if (container.hasClass("survey_entry")) {
        tmpCommunityType = 7; // Survey
    } else if (container.hasClass("ideas_entry")) {
        tmpCommunityType = 8; // Ideas
    }

    $.ajax({
        type: "POST",
        url: "/module/community/ajax.php?action=add_to_favourites",
        datatype: "json",
        data: {
            "ajax_call_id": id,
            "ajax_call_shop_user_id": shopUserId,
            "ajax_call_community_type": tmpCommunityType,
            "ajax_call_community_type_global": communityType,
            "ajax_call_main_language_id": mainLanguageId
        },
        success: function (output) {
            container.find(".add_to_favourites").addClass("active");
        }
    });
}